import logger from "@/services/Logger";
import router from "@/router";
import store from "@/store";
import l10n from "@/services/l10n";

class ErrorHandler {
  add(error) {
    store.dispatch("page/addError", error);
    logger.error(error);
  }
  resolve(error) {
    if (!error && typeof error !== "object") return;

    if (error.code >= 400 && error.code < 500) {
      store.dispatch("page/setStatus", "ready");
      store.dispatch("page/setErrorCode", "notFound");
    }

    if (error.code >= 500 && error.code < 600) {
      store.dispatch("page/setStatus", "ready");
      store.dispatch("page/setErrorCode", "serviceError");
    }

    store.dispatch("page/addError", error);
  }
  form(error) {
    if (error.code >= 400 && error.code < 500) {
      return error.message;
    }

    if (error.code >= 500 && error.code < 600) {
      return l10n("RUNTIME_ERROR_MESSAGE");
    }

    return "";
  }
  handle() {
    const errors = store.getters["page/errors"];

    if (errors.length) {
      // errors.forEach(error => {
      // });
      // TODO: Отправлять ошибки в багтрекер
      // https://sentry.io/
    }
  }
  unauthorizedRequest(error) {
    return error.code == 403;
  }
}

const errorHandler = new ErrorHandler();

errorHandler.plugin = {
  install(app) {
    errorHandler.app = app;

    app.prototype.$errorHandler = errorHandler;

    app.config.errorHandler = error => {
      errorHandler.add(error);
      errorHandler.handle(error);
      store.dispatch("page/setErrorCode", "serviceError");
    };

    router.beforeEach((to, from, next) => {
      if (store.getters["page/errorCode"]) {
        store.dispatch("page/setStatus", "init");
      }

      store.dispatch("page/clearErrors");
      store.dispatch("page/setErrorCode", null);

      next();
    });

    router.afterEach(() => {
      errorHandler.handle();
    });
  }
};

export default errorHandler;
